import { PapiUser } from '@wix/da-papi-types';
import { reduxKey } from './constants';

export function getArtAuthor(state): PapiUser | undefined {
  return state[reduxKey].artAuthor;
}
